export default __webpack_public_path__ + "static/media/classic.f9a95b7a.png";